/**
 * Created by sange on 23/08/2017.
 */

export const DATETIME_FORMAT_FULL = 'dd.MM.yyyy HH:mm:ss'
export const DATE_FORMAT_FULL = 'dd.MM.yyyy'
export const TIME_FORMAT_FULL = 'HH:mm:ss'
export const TIME_FORMAT = 'HH:mm'
export const DATETIME_FORMAT = 'dd.MM HH:mm'
export const DATE_FORMAT_STANDARD = 'YYYY-MM-DD'




// WEBPACK FOOTER //
// ./src/app/shared/time/time.utils.ts